/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Preview_PanInputs */

const en_mk_preview_pan = /** @type {(inputs: Mk_Preview_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll the image to explore workspace details.`)
};

const id_mk_preview_pan = /** @type {(inputs: Mk_Preview_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geser gambar untuk melihat detail workspace.`)
};

/**
* | output |
* | --- |
* | "Scroll the image to explore workspace details." |
*
* @param {Mk_Preview_PanInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_preview_pan = /** @type {((inputs?: Mk_Preview_PanInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Preview_PanInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_preview_pan(inputs)
	return en_mk_preview_pan(inputs)
});